module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "article-container"
    }
  }, _vm._l((_vm.articles), function(article) {
    return _c('section', {
      staticClass: "article-list"
    }, [_c('h1', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(article.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "main-content"
    }, [_c('div', {
      staticClass: "description",
      domProps: {
        "textContent": _vm._s(article.description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "more"
    }, [_c('router-link', {
      attrs: {
        "to": article.url
      }
    }, [_vm._v("More")])], 1)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3ee9d8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/articleList.vue
// module id = 26
// module chunks = 0